/**
 * @generated SignedSource<<b67a307d5cb5825db68a159e33728b26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreReportInput = {
  reportId: string;
};
export type useReportRestoreMutation$variables = {
  input: RestoreReportInput;
};
export type useReportRestoreMutation$data = {
  readonly restoreReport: {
    readonly report: {
      readonly id: string;
      readonly rowId: any;
      readonly company: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type useReportRestoreMutation = {
  variables: useReportRestoreMutation$variables;
  response: useReportRestoreMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreReportPayload",
    "kind": "LinkedField",
    "name": "restoreReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "report",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportRestoreMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportRestoreMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "54e6453b4a77b09a785f8df632139383",
    "id": null,
    "metadata": {},
    "name": "useReportRestoreMutation",
    "operationKind": "mutation",
    "text": "mutation useReportRestoreMutation(\n  $input: RestoreReportInput!\n) {\n  restoreReport(input: $input) {\n    report {\n      id\n      rowId\n      company {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec98f83a27fcaad309d20d699087e34a";

export default node;
